import React from "react";
import BlogCard from "./BlogCard";

const BlogsGrid = ({ blogs }) => {
  return (
    <>
      {/* Blog Grid */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4  gap-3 sm:gap-4 lg:gap-6 xl:gap-8 ">
        {blogs.map((blog, index) => {
          if (blog.status === "published") {
            return (
              <div
                key={blog._id}
                data-aos="fade-up"
                data-aos-offset="100"
                data-aos-delay={index * 100}
              >
                <BlogCard
                  id={blog._id}
                  image={blog.images?.[0]}
                  title={blog.title}
                  // date={blog.date}
                  description={blog.content}
                />
              </div>
            );
          } else {
            return null;
          }
        })}
      </div>
    </>
  );
};

export default BlogsGrid;
